import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import localStorage from 'local-storage';
import superagent from 'superagent';
import config from '../config';
var methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path) {
  var adjustedPath = path[0] !== '/' ? "/".concat(path) : path;

  if (__SERVER__) {
    if (config.apiPort && !isNaN(parseInt(config.apiPort))) {
      return "http".concat(__DEVELOPMENT__ ? '' : 's', "://").concat(config.apiHost, ":").concat(config.apiPort + adjustedPath);
    }

    return "http".concat(__DEVELOPMENT__ ? '' : 's', "://").concat(config.apiHost).concat(adjustedPath);
  } // Prepend `/api` to relative URL, to proxy to API server.


  return "".concat(config.apiEndPoint).concat(adjustedPath);
}

var ApiClient = /*#__PURE__*/function () {
  function ApiClient(req) {
    var _this = this;

    _classCallCheck(this, ApiClient);

    methods.forEach(function (method) {
      _this[method] = function (path) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            params = _ref.params,
            data = _ref.data,
            headers = _ref.headers,
            files = _ref.files,
            fields = _ref.fields;

        return new Promise(function (resolve, reject) {
          var request = superagent[method](formatUrl(path)).withCredentials();

          if (params) {
            request.query(params);
          }

          if (__SERVER__ && req.get('cookie')) {
            request.set('cookie', req.get('cookie'));
          }

          if (headers) {
            request.set(headers);
          }

          if (localStorage.get('accessToken')) {
            request.set({
              accessToken: localStorage.get('accessToken')
            });
          } else if (localStorage.get('inviteToken')) {
            request.set({
              inviteToken: localStorage.get('inviteToken')
            });
          }

          if (_this.token) {
            request.set('Authorization', "Bearer ".concat(_this.token));
          }

          if (files) {
            files.forEach(function (file) {
              if (file.key && file.value) {
                request.attach(file.key, file.value);
              } else if (file.name) {
                request.attach(file.name, file);
              }
            });
          }

          if (fields) {
            fields.forEach(function (item) {
              return request.field(item.key, item.value);
            });
          }

          if (data) {
            request.send(data);
          }

          request.end(function (err) {
            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                body = _ref2.body,
                headers = _ref2.headers;

            if (headers && headers['x-response-time']) {}

            return err ? reject(body || err) : resolve(body);
          });
        });
      };
    });
  }

  _createClass(ApiClient, [{
    key: "setJwtToken",
    value: function setJwtToken(token) {
      this.token = token;
    }
  }]);

  return ApiClient;
}();

export { ApiClient as default };